export default class Time {
  constructor() {
    this.start = Date.now();
    this.current = this.start;
    this.elapsed = 0;
    this.delta = 16;
    this.callbacks = {};

    window.requestAnimationFrame(() => {
      this.tick();
    });
  }

  on(event, callback) {
    if (!this.callbacks[event]) {
      this.callbacks[event] = [];
    }
    this.callbacks[event].push(callback);
  }

  trigger(event) {
    if (this.callbacks[event]) {
      this.callbacks[event].forEach(cb => cb());
    }
  }

  tick() {
    const currentTime = Date.now();
    this.delta = currentTime - this.current;
    this.current = currentTime;
    this.elapsed = (this.current - this.start) * 0.001;

    // Cap delta to prevent huge jumps when switching tabs
    if (this.delta > 60) this.delta = 60;

    this.trigger('tick');

    window.requestAnimationFrame(() => {
      this.tick();
    });
  }
}
